import fetchAPI from '../../../utils/fetchAPI';

type TParams = {
  name: string;
  email: string;
  password: string;
  xsrfToken: string;
  target?: string;
  emailNewsletterOptin?: boolean;
  threatMetrix?: Record<string, any>;
  recaptchaToken: string;
};

type TCreateAccount = {
  accessToken: string;
  userId: number;
};

export default function submitCreateAccount({
  name,
  email,
  password,
  xsrfToken,
  target,
  emailNewsletterOptin,
  threatMetrix,
  recaptchaToken,
}: TParams): Promise<TCreateAccount> {
  return fetchAPI({
    method: 'POST',
    url: '/identity/v2/api/create-account',
    xsrfToken,
    payload: { name, email, password, target, emailNewsletterOptin, threatMetrix, recaptchaToken },
  });
}
